import { createComponent as _$createComponent } from "solid-js/web";
import { render } from "solid-js/web";
import { createSignal } from "solid-js";
import { PublicLayout } from "./pages/public/PublicLayout.tsx";
import { publicRoutes, publicTitles } from "./pages/public/routes.gen.ts";
const root = document.getElementById("page-root");
if (root && publicRoutes[window.location.pathname]) {
  const [path, setPath] = createSignal(window.location.pathname);
  const staging = document.createElement(root.tagName);
  render(
    () => _$createComponent(PublicLayout, { get currentPath() { return path(); }, get children() { return () => {
      const Body = publicRoutes[path()];
      return Body ? _$createComponent(Body, {}) : null;
    }; } }),
    staging
  );
  root.replaceChildren(...staging.childNodes);
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  const go = (pathname, hash, push) => {
    if (push) history.pushState(null, "", pathname + hash);
    setPath(pathname);
    const title = publicTitles[pathname];
    if (title) document.title = title;
    requestAnimationFrame(() => {
      const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
      if (target) target.scrollIntoView();
      else window.scrollTo(0, 0);
    });
  };
  document.addEventListener("click", (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const anchor = e.target?.closest?.("a");
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;
    if (anchor.target && anchor.target !== "_self") return;
    if (anchor.hasAttribute("download")) return;
    if ((anchor.getAttribute("rel") || "").split(/\s+/).includes("external")) return;
    const url = new URL(anchor.href);
    if (url.origin !== location.origin) return;
    if (!publicRoutes[url.pathname]) return;
    if (url.pathname === location.pathname && url.hash) return;
    e.preventDefault();
    const samePage = url.pathname === location.pathname && !url.hash;
    go(url.pathname, url.hash, !samePage);
  });
  window.addEventListener("popstate", () => {
    if (publicRoutes[location.pathname]) go(location.pathname, location.hash, false);
  });
}
